import styled from 'styled-components';
import { setColor, setRem } from '../../utils/styles';
import { motion } from 'framer-motion';

export const Wrapper = styled(motion.div)`
  padding: 0 ${setRem(50)} ${setRem(50)};
  max-width: ${setRem(1024)};
  margin: 0 auto;
`;

export const PageTitle = styled.h1`
  padding: ${setRem(25)} 0;
  max-width: ${setRem(1024)};
  margin: 0 auto;
`;

export const ForecastContainer = styled.div``;

export const HourlyForecastContainer = styled.div`
  display: flex;
  overflow-x: scroll;
  padding-bottom: 20px;
  border-bottom: 1px solid #ccc;
`;

export const HourlyForecast = styled.div`
  flex: 0 0 calc(100% / 10);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const HourlyForecastTime = styled.div`
  font-size: 20px;
`;

export const HourlyForecastRain = styled.div`
  height: 14px;
  margin-top: 12px;
  line-height: 1;
`;

export const HourlyForecastTemp = styled.div`
  font-size: 20px;
  margin-top: 8px;
  font-weight: bold;
  color: ${setColor.primaryColor};
`;

export const HourlyForecastDayDivider = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
  padding: 0 12px;
  color: ${setColor.primaryColor};
`;

export const DailyForecastContainer = styled.div`
  height: 280px;
  overflow-y: scroll;
  max-width: 800px;
  margin: 20px auto 0 auto;
`;

export const DailyForecast = styled.div`
  display: flex;
  padding: 4px 0;
  font-size: 20px;
  align-items: center;
`;

export const DailyForecastDay = styled.div`
  flex: 0 0 40%;
  font-weight: bold;
`;

export const DailyForecastIcon = styled.div`
  display: flex;
  flex: 0 0 30%;
  align-items: center;

  & img {
    max-height: 40px;
  }

  & div {
    margin-left: 8px;
    font-size: 14px;
  }
`;

export const DailyForecastTemp = styled.div`
  display: flex;
  flex: 0 0 30%;
  justify-content: center;

  & span {
    display: inline-block;
    padding: 0 8px;
    color: ${setColor.primaryColor};

    &:nth-child(2) {
      color: #999;
    }
  }
`;
